/**
 * Module-level Logto token provider.
 *
 * LogtoProvider sets the provider function on mount;
 * non-React code (e.g. adminRequest) can call getLogtoToken()
 * to obtain the current access token without React hooks.
 */

type TokenProvider = (resource?: string) => Promise<string | undefined>;

let _provider: TokenProvider | null = null;

export function setLogtoTokenProvider(fn: TokenProvider): void {
  _provider = fn;
}

export function clearLogtoTokenProvider(): void {
  _provider = null;
}

export async function getLogtoToken(resource?: string): Promise<string | undefined> {
  return _provider?.(resource);
}
